// servizi/testoGrande.ts — v037: «testo grande» per chi legge male (anche una signora di una certa età deve poter
// giocare). Tutto l'app è in rem: basta alzare la misura di base. Si ricorda sul telefono.
import { leggiPreferenza, salvaPreferenza } from "./preferenze.ts";
import { PREFERENZE } from "../costanti.ts";

export const testoGrandeAttivo = (): boolean => leggiPreferenza(PREFERENZE.testoGrande) === "si";

export function applicaTestoGrande(si = testoGrandeAttivo()): void {
  if (typeof document !== "undefined") document.documentElement.classList.toggle("ld-testo-grande", si);
}

export function scegliTestoGrande(si: boolean): void {
  salvaPreferenza(PREFERENZE.testoGrande, si ? "si" : "no");
  applicaTestoGrande(si);
}
